import { FormatStructureEditor } from "../FormatStructureEditor";
import { IFormatAlert } from "../IFormatAlert";
import { FormatPropertyEmptyAlert } from "../alerts/FormatPropertyEmptyAlert";
import { FormatPropertyTooLongAlert } from "../alerts/FormatPropertyTooLongAlert";
import { AbstractFormatValidator } from "./AbstractFormatValidator";
import { FormatPropertyQuestionnaireNameAlert } from "../../questionnaire/alerts/FormatPropertyQuestionnaireNameAlert";

export class FormatPropertyValidator extends AbstractFormatValidator {
  constructor() {
    super();
  }

  get companyText(): string {
    return this.configuration.wording.format.attributes.company + "ID";
  }

  get isCompanyCodeEnable(): boolean {
    return this.configuration.formatEditor.behavior.format.editor.attributes.companyCode.isEnable;
  }

  get formatNameText(): string {
    return this.configuration.wording.format.attributes.name + "名";
  }

  get masterCodeText(): string {
    return this.configuration.wording.format.attributes.masterCode;
  }

  get masterCodeMaxLength(): number {
    return this.configuration.formatEditor.behavior.format.editor.attributes.masterCode.maxLength;
  }

  get isQuestionnaireEditable(): boolean {
    return this.configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  public validate(format: FormatStructureEditor): IFormatAlert[] {
    return this.concat(
      this.isQuestionnaireEditable
        ? this.questionnaireValidate(format)
        : this.generalValidate(format),
    );
  }

  private generalValidate(format: FormatStructureEditor): IFormatAlert[] {
    const masterCode = format.masterCode().getValue();
    return this.concat(
      !masterCode
        ? new FormatPropertyEmptyAlert(this.masterCodeText, false)
        : null,
      masterCode && 0 < this.masterCodeMaxLength && this.masterCodeMaxLength < masterCode.length
        ? new FormatPropertyTooLongAlert(this.masterCodeText, true)
        : null,
      this.isCompanyCodeEnable && !format.companyCode().getValue()
        ? new FormatPropertyEmptyAlert(this.companyText, false)
        : null,
      !format.name().getValue()
        ? new FormatPropertyEmptyAlert(this.formatNameText, false)
        : null,
    );
  }

  private questionnaireValidate(format: FormatStructureEditor): IFormatAlert[] {
    const masterCode = format.masterCode().getValue();
    return this.concat(
      !format.name().getValue()
        ? new FormatPropertyEmptyAlert("Questionnaire Title", true)
        : null,
      !masterCode || !/[a-zA-Z0-9]{15}/.test(masterCode)
        ? new FormatPropertyQuestionnaireNameAlert("Questionnaire Name", true)
        : null,
    );
  }
}
